 
import './DestructiveActionModal.css';

export const REASON_MIN_LENGTH = 10;

/**
 * 破壊的操作専用モーダル（確認メッセージ + 削除理由を同一画面で最終確認）
 */
export default function DestructiveActionModal({
  open,
  title = '操作の確認',
  message = '',
  confirmLabel = '削除する',
  reason,
  onReasonChange,
  onClose,
  onConfirm,
  loading = false,
}) {
  if (!open) return null;

  const reasonLen = (reason || '').trim().length;
  const reasonValid = reasonLen >= REASON_MIN_LENGTH;

  return (
    <div className="modal-overlay destructive-modal-overlay" onClick={onClose}>
      <div
        className="modal modal-wide destructive-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-header destructive-modal-header">
          <h2>{title}</h2>
          <button type="button" className="modal-close" onClick={onClose} aria-label="閉じる">
            &times;
          </button>
        </div>
        <div className="modal-body">
          {message ? <p className="destructive-modal-message">{message}</p> : null}
          <label className="destructive-modal-reason-label" htmlFor="destructive-action-reason">
            削除理由（{REASON_MIN_LENGTH}文字以上）
          </label>
          <textarea
            id="destructive-action-reason"
            className="destructive-modal-reason"
            value={reason || ''}
            onChange={(e) => onReasonChange?.(e.target.value)}
            rows={4}
            placeholder="例: テストデータのため本番環境から除去"
            autoFocus
          />
          <p className={`destructive-modal-counter${reasonValid ? ' valid' : ''}`}>
            {reasonLen} / {REASON_MIN_LENGTH} 文字
          </p>
          <p className="destructive-modal-hint">理由を入力して「{confirmLabel}」を押すと実行されます。この操作は取り消せません。</p>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>
            キャンセル
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={onConfirm}
            disabled={loading || !reasonValid}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
